import { useTranslation } from "react-i18next";
import { useNavigate, useNavigation } from "react-router-dom";

function BookingHero() {
  return (
    <div className="absolute inset-0 z-0">
      <img
        src="https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?auto=format&fit=crop&w=2000&q=80"
        alt="Luxury Car"
        className="object-cover w-full h-full"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900/60 via-slate-800/50 to-slate-900/60"></div>
    </div>
  );
}

BookingHero.Content = function BookingHeroContent() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="hidden px-4 space-y-8 text-white lg:block lg:px-8">
      <div className="space-y-3">
        <p className="text-base md:text-lg uppercase tracking-widest text-[#f5272b] font-medium">
          {t("your_trustedcar_rental_in_bali")}
        </p>
        <h1 className="text-5xl font-bold leading-tight md:text-6xl lg:text-7xl">{t("simple_booking")}</h1>
      </div>

      <p className="max-w-xl text-lg leading-relaxed text-slate-200 md:text-xl">{t("we_provide_flexible")}</p>

      <button
        onClick={() => navigate("/about-us")}
        className="bg-[#f5272b] hover:bg-red-600 text-white font-semibold text-lg px-10 py-4 rounded transition-all duration-300 transform hover:scale-105"
      >
        {t("learn_more")}
      </button>
    </div>
  );
};

export default BookingHero;
